import { Dumpster } from "../../../models";

export const getDumpster = (data: any): Dumpster => {
  return {
    id: data.id,
    label: data.attributes.label,
    dumpsterSize: data.attributes.dumpster_size,
    notes: data.attributes.notes,
    locationType: data.attributes.location_type || "unknown",
    fillStatus: data.attributes.fill_status || "empty",
    currentOrderId: data.attributes.current_order_id,
    currentStorageYardId: data.attributes.current_storage_yard_id,
    currentVehicleId: data.attributes.current_vehicle_id || undefined,
    currentAddress: data.attributes.current_address || "",
    currentCity: data.attributes.current_city || "",
    currentZip: data.attributes.current_zip || "",
    customerName: data.attributes.customer_name || "",
    orderLatitude: data.attributes.order_latitude,
    orderLongitude: data.attributes.order_longitude,
  };
};

export const getDumpsters = (data: any): Dumpster[] => {
  return data.map(getDumpster);
};
